/**
 * Public surface of the orqestrator chat client.
 *
 * Consumers import from here, so the internal split between request shaping,
 * event folding and transport can change without touching call sites.
 */
export { OrqClient } from "./client";
export { OrqChatError } from "./errors";
export { userContextVariables } from "./promptContext";
export { mintOrqToken, OrqTokenError } from "./token";